// extracted by mini-css-extract-plugin
export var background = "Hero-module--background--3a027";
export var backgroundImage = "Hero-module--backgroundImage--ea276";
export var content = "Hero-module--content--82655";
export var heading = "Hero-module--heading--69610";
export var hero = "Hero-module--hero--f6f1b";
export var overlay = "Hero-module--overlay--d3caf";
export var poster = "Hero-module--poster--0ea10";
export var subheading = "Hero-module--subheading--9dddc";
export var textWrapper = "Hero-module--textWrapper--4e47f";
export var video = "Hero-module--video--9826e";
export var videoElement = "Hero-module--videoElement--df8bd";
export var videoWrapper = "Hero-module--videoWrapper--92646";